import ListCreateButton from 'components/buttons/ListCreateButton';
import PageHeader from 'components/PageHeader';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import { useNavigateWithReturnState } from 'utils/useNavigateWithReturnState';
import CorrespondenceTableWithFilters from './CorrespondenceTable';

const CorrespondenceListPage = () => {
    const navigateWithReturn = useNavigateWithReturnState();
    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader
                    hostsList
                    titleId="correspondence.correspondence"
                    showBreadcrumb
                    buttons={
                        <ListCreateButton
                            permissions={['CREATE.CORRESPONDENCE']}
                            variant="contained"
                            color="secondary"
                            size="small"
                            onClick={() => navigateWithReturn(`/correspondence/new`)}
                            labelId="correspondence.add-correspondence"
                            newLabelId="new-entity.correspondence"
                        />
                    }
                />
                <CorrespondenceTableWithFilters />
            </div>
        </PaddedLayout>
    );
};

export default CorrespondenceListPage;
